import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { TaskCalendarPage } from 'pages/task-calendar-page/task-calendar-page';

@NgModule({
  declarations: [TaskCalendarPage],
  imports: [PagesModule, ComponentsModule],
  exports: [TaskCalendarPage]
})
export class TaskCalendarPageModule { }
